import styled from 'styled-components';

export const List = styled.ol`
  position: relative;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const Info = styled.div`
  margin-left: 0;
`;

export const Item: any = styled.li`
  display: flex;
  align-items: center;
  padding: 28px 0px 28px 41px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.navigationMenu.border};

  &:hover {
    background-color: ${({ theme }) => theme.navigationMenu.background};
  }
`;

Item.Name = styled.span`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.userMenu.nameColor};
`;

export const RightArrow = styled.div`
  position: absolute;
  right: 24px;
`;
